import { steps } from './constant';
import checkIcon from '../../../../assets/images/performance/checkIcon.svg';

function HeaderSteps({ performanceHeader, isLoading }) {
  const headerData = performanceHeader?.[0];

  if (isLoading) return <div className="stepBar">Loading...</div>;

  return (
    <div className="stepBar">
      {steps.map((item, index) => {
        const isDone = headerData?.[item?.key] === 2;
        const isActive = headerData?.[item?.key] === 1;

        let stepStatusClass = 'pending';
        if (isDone) {
          stepStatusClass = 'done';
        } else if (isActive) {
          stepStatusClass = 'active';
        }

        return (
          <div
            key={index}
            className={`stepBox ${stepStatusClass}`}
            style={{ cursor: 'pointer' }}
            title={item.tooltip}
          >
            <div className="stepIcon">
              <img src={item.icon} height={72} alt="Step icon" />
            </div>
            <div className="fw-semibold stepTitle fs-5">{item.title}</div>
            {stepStatusClass === 'done' && (
              <img src={checkIcon} className="checkIcon" height={18} alt="" />
            )}
          </div>
        );
      })}
      <hr className="line" />
    </div>
  );
}

export default HeaderSteps;
